import styled from 'styled-components6';

export type ButtonStyle = 'solid' | 'outline' | 'ghost';

export const ButtonBase = styled.a.attrs({ role: 'button' })`
    display: flex;
    flex-direction: row;
    gap: var(--rwl-spacing-sm);
    justify-content: center;
    align-items: center;

    user-select: none;

    padding-bottom: var(--rwl-spacing-sm);
    padding-top: var(--rwl-spacing-sm);
    padding-left: var(--rwl-spacing-md);
    padding-right: var(--rwl-spacing-md);

    background: none;
    color: inherit;
    border: none;
    font: inherit;
    cursor: pointer;
    outline: inherit;

    // Themify this... but how..
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    text-decoration: none;
`;

export const ButtonBaseStandalone = styled(ButtonBase)`
    border-radius: var(--rwl-radius-xs);
`;

export const SolidButtonPrimary = styled(ButtonBaseStandalone)`
    background-color: var(--rwl-color-primary-default);
    color: var(--rwl-text-alternative);

    &:hover {
        background-color: var(--rwl-color-primary-hover);
    }

    &:active {
        background-color: var(--rwl-color-primary-active);
    }
`;

export const OutlineButtonNeutral = styled(ButtonBaseStandalone)`
    border: 1px solid var(--rwl-color-neutral-border);
    color: var(--rwl-text-default);

    &:hover {
        background-color: var(--rwl-color-neutral-light);
    }

    &:active {
        background-color: var(--rwl-color-neutral-light-hover);
    }
`;

export const GhostButtonNeutral = styled(ButtonBaseStandalone)`
    color: var(--rwl-text-default);

    &:hover {
        background-color: var(--rwl-color-neutral-light-hover);
    }

    &:active {
        background-color: var(--rwl-color-neutral-light-active);
    }
`;
